import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { MobileStepper } from "@mui/material";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const useStyles = makeStyles(theme => ({
  root: {
    position: "relative",
    boxShadow: "inset 0px -1px 2px rgba(0, 0, 0, 0.12)"
  },
  stepper: {
    position: "absolute",
    background: "none",
    marginLeft: -35,
    bottom: 28
  },
  dot: {
    backgroundColor: "rgba(255, 255, 255, 0.4)"
  },
  dotActive: {
    backgroundColor: theme.palette.common.white
  }
}));

export default function Carousel(props) {
  const { steps, swipeOnClick, alignDots, pause } = props;
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  function handleStepChange(step) {
    if (Number.isInteger(step)) {
      setActiveStep(step);
    }
  }
  function swipeImage() {
    if (swipeOnClick) {
      setActiveStep(activeStep + 1 === steps.length ? 0 : activeStep + 1);
    }
  }
  const dotsPositionStyle =
    alignDots === "center"
      ? {
          left: "50%"
        }
      : {
          right: 28
        };

  return (
    <div className={classes.root} onClick={swipeImage}>
      <AutoPlaySwipeableViews
        interval={5000}
        axis="x"
        index={activeStep}
        onChangeIndex={handleStepChange}
        autoPlay={!pause}
      >
        {steps}
      </AutoPlaySwipeableViews>
      {steps.length > 1 && (
        <MobileStepper
          variant="dots"
          steps={steps.length}
          position="static"
          activeStep={activeStep}
          classes={{
            root: classes.stepper,
            dot: classes.dot,
            dotActive: classes.dotActive
          }}
          style={dotsPositionStyle}
        />
      )}
    </div>
  );
}

Carousel.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.any),
  alignDots: PropTypes.oneOf(["center", "end"]),
  pause: PropTypes.bool
};

Carousel.defaultProps = {
  alignDots: "center",
  pause: false
};
